export const TIPO_DE_DOCUMENTOS = [
    { label: 'Ata de registro de preço', value: 'Ata de registro de preço' },
    { label: 'Aviso de adiamento de licitação', value: 'Aviso de adiamento de licitação' },
    { label: 'Aviso de homologação', value: 'Aviso de homologação' },
    { label: 'Aviso de julgamento de habilitação', value: 'Aviso de julgamento de habilitação' },
    { label: 'Aviso de julgamento de propostas', value: 'Aviso de julgamento de propostas' },
    { label: 'Aviso de licitação', value: 'Aviso de licitação' },
    { label: 'Aviso de recurso e adiamento', value: 'Aviso de recurso e adiamento' },
    { label: 'Aviso de resultado', value: 'Aviso de resultado' },
    { label: 'Contrato', value: 'Contrato' },
    { label: 'Edital', value: 'Edital' },
    { label: 'Extrato de contrato', value: 'Extrato de contrato' },
    { label: 'Minuta de contrato', value: 'Minuta de contrato' },
    { label: 'Publicação aviso de resultado', value: 'Publicação aviso de resultado' },
    { label: 'Publicação aviso de adiamento de licitação', value: 'Publicação aviso de adiamento de licitação' },
    { label: 'Publicação aviso de julgamento de habilitação', value: 'Publicação aviso de julgamento de habilitação' },
    { label: 'Publicação aviso de julgamento de propostas', value: 'Publicação aviso de julgamento de propostas' },
    { label: 'Publicação ata de registro de preço', value: 'Publicação ata de registro de preço' },
    { label: 'Publicação aviso de licitação', value: 'Publicação aviso de licitação' },
    { label: 'Publicação extrato de contrato', value: 'Publicação extrato de contrato' },
    { label: 'Publicação de homologação', value: 'Publicação de homologação' },
    { label: 'Aditivo', value: 'Aditivo' },
    { label: 'Adiamento', value: 'Adiamento' },
    { label: 'Anexos', value: 'Anexos' },
    { label: 'Ata', value: 'Ata' },
    { label: 'Ata de Julgamento de Propostas', value: 'Ata de Julgamento de Propostas' },
    { label: 'Ata de Julgamento de Habilitação', value: 'Ata de Julgamento de Habilitação' },
    { label: 'Aviso de Cancelamento', value: 'Aviso de Cancelamento' },
    { label: 'Impugnação do Edital', value: 'Impugnação do Edital' },
    { label: 'Parecer de Recurso', value: 'Parecer de Recurso' },
    { label: 'Planilhas', value: 'Planilhas' },
    { label: 'Reabertura', value: 'Reabertura' },
    { label: 'Recurso', value: 'Recurso' },
    { label: 'Republicação do Edital', value: 'Republicação do Edital' },
    { label: 'Processo na íntegra', value: 'Processo na íntegra' },
    { label: 'Parecer Jurídico', value: 'Parecer Jurídico' }
];



// WEBPACK FOOTER //
// ./src/app/_mocks/tipoDeDocumentos.ts